/**
 * Kullanım telemetrisi modül adları API route'undan gelir.
 * Şirket/şube gibi altyapı uçları ısı haritasından düşülür — onlar
 * organizasyon birimi değil, her sayfada çekilen ayar istekleridir.
 * Sayı = o şirketin o iş modülüne attığı API istek sayısı.
 */
const INFRASTRUCTURE_MODULES = new Set([
  'company',
  'branch',
  'branch-personnel-assignments',
  'users',
  'user',
  'auth',
  'superadmin',
  'health',
  'notifications',
  'notification',
]);

const MODULE_LABELS_TR: Record<string, string> = {
  company: 'Şirket ayarları',
  branch: 'Şube ayarları',
  sales: 'Satış',
  users: 'Kullanıcılar',
  user: 'Kullanıcılar',
  personnel: 'Personel',
  accounting: 'Muhasebe',
  inventory: 'Stok',
  cashbox: 'Kasa',
  bank: 'Banka',
  wms: 'Akıllı Depo',
  ecommerce: 'E-ticaret',
  qrmenu: 'QR Menü',
  kiosk: 'Kiosk',
  kioskproductvisibility: 'Kiosk Ürünleri',
  kioskassignment: 'Kiosk Atama',
  masasiparisi: 'Masa Siparişi',
  table: 'Masa',
  reservations: 'Rezervasyonlar',
  ticketreservation: 'Bilet Rezervasyonu',
  couriers: 'Kuryeler',
  courieractiveorders: 'Kurye Siparişleri',
  payment: 'Ödeme',
  payments: 'Ödemeler',
  paymentterminal: 'Ödeme Terminali',
  paymentproviderintegration: 'Ödeme Entegrasyonu',
  platformintegration: 'Pazaryeri Entegrasyonu',
  catalog: 'Katalog',
  catalogbrowse: 'Katalog',
  sellerinfo: 'Satıcı Bilgisi',
  dailyclosing: 'Gün Sonu',
  supportchat: 'Canlı Destek',
  fiscaldevice: 'Yazarkasa',
  dealermanagement: 'Bayi Yönetimi',
  device: 'Cihaz',
  hr: 'İnsan Kaynakları',
  reports: 'Raporlar',
  mailreports: 'Mail Raporları',
  contactleads: 'İletişim Talepleri',
  callcenter: 'Çağrı Merkezi',
  quicksaleannouncement: 'Hızlı Satış Duyurusu',
  haciogluexport: 'Hacıoğlu Aktarım',
  haciogluimport: 'Hacıoğlu İçe Aktarım',
  haciogluproductmapping: 'Hacıoğlu Eşleme',
  hacioglusyncadmin: 'Hacıoğlu Senkron',
  other: 'Diğer',
};

export function usageModuleLabel(module?: string | null): string {
  if (!module) return 'Diğer';
  const key = module.trim().toLowerCase();
  return MODULE_LABELS_TR[key] || module;
}

/** Isı haritası / modül listesinde gösterilecek iş modülü mü? */
export function isUsageProductModule(module?: string | null): boolean {
  if (!module) return false;
  return !INFRASTRUCTURE_MODULES.has(module.trim().toLowerCase());
}
